import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from './../shared/modules/shared.module';
import { MomentModule } from 'ngx-moment'
import { PractitionerComponent } from './practitioner.component';
import { PractitionerService } from './shared/services/practitioner.service';
import { PartialProfileService } from './shared/services/partial-profile.service';
import { PractitionerMocksService } from './../shared/services/mocks/practitioner-mocks.service';
import { ProfileComponent } from './profile/profile.component';
import { EditComponent } from './profile/edit/edit.component';
import { CredentialsMaintenanceModule } from './credentials-maintenance/credentials-maintenance.module';
import { PurchaseDetailComponent } from "./purchase-detail/purchase-detail.component";
import { PurchaseHistoryComponent } from './purchase-history/purchase-history.component';
import { PartialProfileComponent } from './partial-profile/partial-profile.component';
import { DemographicEditComponent } from './profile-demographics/edit/demographic-edit.component';
import { MyDocumentsComponent} from './mydocuments/mydocuments.component';
import { UploadDocumentsComponent } from './mydocuments/upload-documents/upload-documents.component';
import { UploadDocumentsService } from './mydocuments/upload-documents/shared/upload-documents.service';
import { CertificateViewComponent } from './mydocuments/certificates/certificates-view.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgxMaskModule } from 'ngx-mask';

@NgModule({
  imports: [
    SharedModule,
    RouterModule,
    CredentialsMaintenanceModule,
    MomentModule,
    NgMultiSelectDropDownModule,
    NgxMaskModule.forRoot()
  ],
  providers: [
    PractitionerService, 
    PractitionerMocksService,
    PartialProfileService,
    UploadDocumentsService],
  declarations: [
    PractitionerComponent,
    ProfileComponent,
    EditComponent,
    PurchaseDetailComponent,
    PurchaseHistoryComponent,
    PartialProfileComponent,
    DemographicEditComponent,
    MyDocumentsComponent,
    UploadDocumentsComponent,
    CertificateViewComponent
  ]
})
export class PractitionerModule { }
